import * as React from 'react'
import { connect } from 'react-redux'

import * as actions from '../../../actions'
import { getStore } from '../../../initializers/redux'
import { reconfigureApi } from '../../../utilities/configureApi'
import { requestCredentials } from '../../../webview'
import { DasherCredentials } from '../../../webview/types'
import Page from '../../molecules/page'

type WebViewProps = {
  loadDasherId: () => void
}

/**
 * iOS has an issue with WKWebView where it will strip custom headers. This
 * means we cannot get the authorization token through normal means. Until
 * identity/iOS team comes up with a solution we will use message passing for
 * now. A message is passed to iOS via requestCredentials() in the
 * componentDidMount and once the messaÎge is recieved it should call
 * setDasherCredentials, passing in the authorization token and the dasherId as
 * parameters
 */
declare const window
window.setDasherCredentials = ({ token, dasherId }: DasherCredentials) => {
  const store = getStore()
  reconfigureApi(token)
  store.dispatch(actions.setDasherId(dasherId))
}

/**
 * Basic Webview wrapper that will provide authentication header setup to
 * support Android and iOS
 */
class WebViewWrapper extends React.Component<WebViewProps> {
  public componentDidMount() {
    // no-op to by pass onboarding configuration with uniqueLink
    // tslint:disable-next-line:no-empty
    requestCredentials(() => {})
    this.props.loadDasherId()
  }

  /**
   * render children wrapped in styled page div
   */
  public render() {
    return (
      <React.Fragment>
        <Page>{this.props.children}</Page>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  loadDasherId: actions.loadDasherId,
}

export default connect(
  null,
  mapDispatchToProps
)(WebViewWrapper)
